import { Helmet } from 'react-helmet'
import Header from '../../../../Components/Header'
import MainContent from './MainContent'
function BankClearance() {
    return (
        <div className='d-flex flex-column' style={{ minHeight: '99.7vh' }}>
            <Helmet>
                <title>Bank Clearance List</title>
            </Helmet>
            <Header />
            <MainContent />
            {/* <Footer /> */}
        </div>
    )
}

export default BankClearance
